import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=0f0ae312&scoped=true"
import script from "./Validation.vue?vue&type=script&lang=js"
export * from "./Validation.vue?vue&type=script&lang=js"
import style0 from "./Validation.vue?vue&type=style&index=0&id=0f0ae312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ae312",
  null
  
)

/* custom blocks */
import block0 from "./Validation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports